import Layout from 'components/layout';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Home from './home';
import Movie from './movie';
export default function Views() {
  const APP_ROUTES = [
    {
      path: '/',
      exact: true,
      element: <Home />,
      title: 'Trang chủ',
    },
    {
      path: '/xem-phim',
      exact: true,
      element: <Movie />,
      title: 'Trang chủ',
    },
  ];
  return (
    <Scrollbars style={{width: '100%', height: '100vh'}} autoHide autoHideDuration={1000}>
      <Layout>
        <Router>
          <Routes>
            {APP_ROUTES.map((e, index) => (
              <Route {...e} key={index}></Route>
            ))}
          </Routes>
        </Router>
      </Layout>
    </Scrollbars>
  );
}
